import { clampRound } from './clamp';
var abs = Math.abs,
    floor = Math.floor,
    round = Math.round;
export function clampIndex(index, length) {
  var count = floor(abs(length)) || 1;
  return clampRound(index, 0, count - 1);
}
export function clampIndexLoop(index, length) {
  var count = floor(abs(length)) || 1;
  return (round(index) % count + count) % count;
}
export function clampPage(page, pageCount) {
  return clampIndex(page - 1, pageCount) + 1;
}
export function clampPageLoop(page, pageCount) {
  return clampIndexLoop(page - 1, pageCount) + 1;
}